const doc = [({"zh_cn":({"adminLabelHotelFilter":({"filterName":"筛选条件名称", "masterFilterId":"筛选条件", "type":"类型"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;